import { render, staticRenderFns } from "./nxTags.vue?vue&type=template&id=67a303fe&"
import script from "./nxTags.vue?vue&type=script&lang=js&"
export * from "./nxTags.vue?vue&type=script&lang=js&"
import style0 from "./nxTags.vue?vue&type=style&index=0&id=67a303fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports